import { apiPost, clearSession, getSession } from './api.js';

/** Revokes the session server-side, then clears it locally regardless of whether that call succeeds. */
export async function signOut(redirectTo = '/box'): Promise<void> {
  const session = getSession();
  if (session) {
    await apiPost('/member/v1/logout', {}).catch(() => undefined);
  }
  clearSession();
  window.location.href = redirectTo;
}
